module.exports = __webpack_public_path__ + "img/presssion.cef52d3c.svg";